function isCachable($link) {
  let cacheAllowed = $link.attr('up-cache') !== 'false'
  let cachableUrl = !String($link.attr('href')).match(/\/edit(\?|#|$)/)

  return cacheAllowed && cachableUrl
}

function setAttributes($link, attributes) {
  let attrs = Object.assign({ 'up-instant': '' }, attributes)

  if (isCachable($link)) {
    attrs['up-preload'] = ''
  } else {
    attrs['up-cache'] = 'false'
  }

  if ($link.is('.btn:not(.btn-link)')) {
    // Buttons should not navigate on mousedown
    delete attrs['up-instant']
  }

  $link.attr(attrs)
}

module.exports = {
  setAttributes: setAttributes,
}
